import React, { useEffect, useMemo} from 'react';
import { batch, useSelector, useDispatch } from 'react-redux';
import { Map as OlMap, View } from 'ol';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import Overlay from 'ol/Overlay';
import Select from 'ol/interaction/Select';
import { Icon, Style, Text, Fill } from 'ol/style';

import markerActive from '../images/marker_active.svg';

const iconStyleActive = new Style({
  image: new Icon({
    size:[48,48],
    anchor: [24, 36],
    anchorXUnits: 'pixels',
    anchorYUnits: 'pixels',
    src: markerActive,
  }),
  text: new Text({
      offsetY: -13,
      font: `bold 9px Cerebri Sans`,
      fill: new Fill({
          color: '#206052'
      })
  })
});

const select = new Select({
  style: function (feature,l) {
    let t = 0
    if(feature.getProperties().studyId){
      t = feature.getProperties().studyId
      t = t.length
      iconStyleActive.getText().setText(`${t > 1 ? t : ''}`);
      return iconStyleActive;
    }

    return;
  }
});

const Map = () => {
  const setApp = useDispatch();
  const { allStudies } = useSelector(s => s.allStudies);

  useEffect(() => {
    const popup = new Overlay({
      element: document.getElementById('id-overlay'),
      offset: [0, -20]
    });

    const olmap = new OlMap({
      target: 'map',
      layers: [
        new TileLayer({
          source: new XYZ({
            attributions: "Tiles ©<a rel='noopener' href='https://www.google.com/intl/en_id/help/terms_maps/'> Google</a>",
            url: "https://mt1.google.com/vt/lyrs=p&hl=en&x={x}&y={y}&z={z}"
          }),
          zIndex: 0,
          name: 'bMap'
        })
      ],
      view: new View({
        center: [0, 0],
        zoom: 0,
        maxZoom: 12
      })
    });

    setApp({ type: '_MAP', payload: ['map', olmap] });
    setApp({ type: '_MAP', payload: ['select', select] });

    olmap.addOverlay(popup);

    olmap.on('pointermove', function (e) {
      const pixel = olmap.getEventPixel(e.originalEvent);
      const hit = olmap.hasFeatureAtPixel(pixel);
      this.getTargetElement().style.cursor = hit ? 'pointer' : '';

      const element = popup.getElement();

      if (hit) {
        $(element).popover('dispose');
        olmap.forEachFeatureAtPixel(e.pixel, function (f) {
          if (f.getProperties().s) {
            const coordinate = f.getGeometry().getCoordinates();
            popup.setPosition(coordinate);
            $(element).popover({
              container: element,
              placement: 'top',
              animation: false,
              html: true,
              content: [
                '<p>Site ID: <b>',
                f.getProperties().s,
                '</b></p><small>(',
                f.getProperties().c,
                ')</small>'
              ].join(''),
            });
            $(element).popover('show');
          } else {
            popup.setPosition(undefined);
          }

          return true;
        });
      } else {
        $(element).popover('dispose');
      }
    });

    olmap.on('singleclick', function (e) {
      let f = [];
      let clusterClicked = !1;
      olmap.forEachFeatureAtPixel(e.pixel, (feature, layer) => {
        const ln = layer.get('name');

        if (ln === 'markers' || ln === 'active-markers') {
          return f = [...f, feature];
        }
        if (ln === 'cluster-markers') {
          return clusterClicked = feature.values_.features.length;
        }
      });

      const zoom = olmap.getView().getZoom();

      const showdata = () => {
        let at = f[0].getProperties();
        const _id = at.studyId;

        olmap.addInteraction(select);

        const sb = document.querySelector('#map');
        if (sb) {
          if (
            (" " + sb.className + " ")
              .replace(/[\n\t]/g, " ")
              .indexOf(" open ") === -1
          ) {
            document.querySelector('#map').classList.toggle("open");
            document.querySelector('#sidebar').classList.toggle("open");
            // setTimeout(() => {
            //   olmap.updateSize();
            // }, 270);
          }
        }

        if (allStudies) {
          batch(() => {
            setApp({ type:'_STUDY_DETAIL', payload: ['studyID', at.studyId] });
            if (_id.length === 1) {
              setApp({ type: '_STUDY_DETAIL', payload: ['studySite', null] });
            } else {
              setApp({
                type: '_STUDY_DETAIL',
                payload: ['studySite', [at.s, at.n, at.c]]
              });
              setApp({ type: '_STUDY_DETAIL', payload: ['studyTotal', at.t] });
            }
          })
        }

      }

      if (f.length) {
        showdata();
      } else {
        olmap.removeInteraction(select);
        if (clusterClicked) {
          olmap.getView().animate({
            center: olmap.getCoordinateFromPixel(e.pixel),
            zoom: clusterClicked > 1 ? zoom + 1 : 6.1,
            duration: 500
          });
        }
      }
    });

  }, []);

  return useMemo(() => {
    return (
      <div id="map" className="open">
        <div id="id-overlay"></div>
      </div>
    )
  }, []);
}

export default Map;
